<template>
  <div :class="classList">
    <label v-if="label" class="d-flex"
      >{{ label.trim().replace(/\*$/, "") }}
      <span v-if="isRequired" class="asterisk-mark">*</span>
    </label>
    <div
      v-if="adminDescription && $store.getters.isAgent"
      class="admin-description"
    >
      <div v-html="adminDescription"></div>
    </div>
    <div v-if="description" class="description">
      <div v-html="description"></div>
    </div>
    <select class="form-control" v-model="inputVal" :disabled="isDisabled">
      <option
        v-for="(option, index) in normalizedOptionList"
        :key="'option' + index"
      >
        {{ getDisplayOption(option) }}
      </option>
    </select>
    <p class="required-message" v-if="!inputVal && submitClicked && isRequired">
      {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
    </p>
  </div>
</template>
<script>
/* This component includes a label, and a dropdown list
Any error of the dropdown list (for example: required field) is showed in this component */
export default {
  name: "DropdownWithLabel",
  props: {
    /* Name of the dropdown component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12",
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    // Input value, which is used for v-model
    value: String,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false,
    },
    // Index of default selected option
    defaultValue: [Number, String],
    optionList: {
      type: [Array, String],
    },
    // Map option list to display in multiple languages
    mapOptionListByLang: {
      type: Object,
      default: () => {},
    },
    builderField: Object,
  },
  // created() {
  //   this.$emit("input", this.normalizedOptionList[0]);
  // },
  created() {
    if (this.value) {
      // Reset value if it is not included in option list
      if (!this.normalizedOptionList.includes(this.value)) {
        this.$emit("input", null);
      }
    }
    if (this.defaultValue != null && this.value == null) {
      this.$emit("input", this.normalizedOptionList[this.defaultValue]);
    }
  },
  computed: {
    normalizedOptionList() {
      if (Array.isArray(this.optionList)) {
        return this.optionList;
      }
      return this.optionList
        .split("\n")
        .map((option) => option.trim())
        .filter((option) => option.length > 0);
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getDisplayOption(option) {
      if (!this.mapOptionListByLang) {
        return option;
      }
      if (this.mapOptionListByLang[option]) {
        return this.mapOptionListByLang[option];
      }
      return option;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/form-elements/DropdownWithLabel.vue